import React from 'react'
import { Button, Table } from 'antd'
import './index.sass'
import api from '../../../../utils/api'

export default class ChangeChannels extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            dataSource: [],
        }
    }

    componentDidMount() {
        this.getChannels();
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (nextProps.token.value && nextProps.token.value !== this.props.token.value) {
            this.getChannels();
        }
        return true;
    }

    getChannels = async () => {//获取渠道
        let res = await api('get-channels');
        if (res.code === 200) {
            this.setState({
                dataSource: res.data
            })
        }
        console.log(res)
    }

    closeHandle = () => {
        this.props.colsePop(false)
    }
    

    render() {
        let { dataSource } = this.state;
        const rowSelection = {
            type: 'radio',
            onChange: (selectedRowKeys, selectedRows) => {

            },
        };
        const columns = [
            {
                title: '渠道名称',
                dataIndex: 'name',
                key: 'name',
            },
            {
                title: '备注',
                dataIndex: 'desc',
                key: 'desc',
            }
        ];
        return (
            <div className='changeChannels'>
                <div className='close'></div>
                <div className='popBox'>
                    <p className='title'>
                        更换渠道
                    </p>


                    <div className='popContent'>

                        <Table scroll={{ y: 400 }} pagination={false} rowSelection={{
                            ...rowSelection,
                        }} dataSource={dataSource} columns={columns} />

                        <div className='flex mgtb20'>
                            <Button className='mgr20 themeColor themeBtn'>确定</Button>
                            <Button onClick={()=>{ this.closeHandle() }}>取消</Button>
                        </div>
                    </div>


                </div>
            </div>
        )
    }
}